/** EquipmentSlot::LIST identities shared by equipment display and rule readers. */
export const EQUIPMENT_SLOTS = {
    air_around:    'F2D8C4B3-FA31-291C-995A-2046F84A289F',
    head:          '3805BDD7-3461-DDDB-F445-922A5A992987',
    neck:          '5EDE9876-ED2B-3B93-C683-34428B5FDA5B',
    natural_armor: '3CA73C13-5DC3-0DDF-CAD8-98D1CF573844',
    armor:         '0B279A55-5102-D704-8A57-0C1FF4989DFA',
    back:          'F19F7A27-C0EE-DCFF-BD8F-2FA3CC03F7BB',
    bracers:       'BD255B29-389B-53DC-6116-072B1A8DDD5F',
    clothing:      '3CAA3182-3DA6-F348-CEE3-09803F221466',
    cloak:         '6203F9AE-6699-AB57-B3C7-92864A79520C',
    ring:          '3AD8CEE8-D487-68B1-33F0-CFE04336F9B8',
    breast:        'C48555B1-E374-9AAD-8CA0-C55D07AD6776',
    waist:         'B52059C5-526B-3F8C-E906-0D40FA23A593',
    legs:          'AF43D701-0755-C7E2-D26F-44E6F64AC3E2',
    feet:          '94805078-0B0F-FD3F-77E4-AA6EE4D2E44D',
    main_hand:     'CEF334BF-DE96-1BEA-F72A-A4C98FBF36AD',
    off_hand:      '4FF85144-67EC-9D87-AE28-15137A1A2481',
    both_hands:    'E6D02ACB-D3E9-DD8B-762A-31FE8C8D898D',
    tail:          '16ABAE95-5D18-474D-ADFF-8C20FC2439F1',
} as const;
